import { render, staticRenderFns } from "./ProfileSet.vue?vue&type=template&id=b66f36ec&scoped=true&"
import script from "./ProfileSet.vue?vue&type=script&lang=js&"
export * from "./ProfileSet.vue?vue&type=script&lang=js&"
import style0 from "./ProfileSet.vue?vue&type=style&index=0&id=b66f36ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b66f36ec",
  null
  
)

export default component.exports